export default "__VITE_ASSET__CUf26BMw__"